const ItemLabel = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="236.903"
      height="150.551"
      {...props}
    >
      <defs>
        <clipPath id="a" clipPathUnits="userSpaceOnUse">
          <path d="M-15.835 47.963h177.677V-64.95H-15.837Z" />
        </clipPath>
        <clipPath id="b" clipPathUnits="userSpaceOnUse">
          <path d="M-161.841 47.963H15.836V-64.95h-177.677Z" />
        </clipPath>
        <clipPath id="c" clipPathUnits="userSpaceOnUse">
          <path d="M-88.889 25.306H88.788V-87.607H-88.889Z" />
        </clipPath>
      </defs>
      <path
        d="M0 0s-.388 13.204 3.304 21.081c0 0 3.493 5.554 5.641-4.19 2.149-9.745 2.404-10.716 2.404-10.716S2.695 1.931 0 0"
        clip-path="url(#a)"
        fill="currentColor"
        filter="brightness(0.5)"
        fillOpacity="1"
        fillRule="nonzero"
        stroke="none"
        transform="matrix(1.33333 0 0 -1.33333 21.114 63.95)"
      />
      <path
        d="M0 0s.388 13.204-3.304 21.081c0 0-3.493 5.554-5.641-4.19-2.149-9.745-2.404-10.716-2.404-10.716S-2.695 1.931 0 0"
        clip-path="url(#b)"
        fill="currentColor"
        filter="brightness(0.5)"
        fillOpacity="1"
        fillRule="nonzero"
        stroke="none"
        transform="matrix(1.33333 0 0 -1.33333 215.788 63.95)"
      />
      <path
        d="M0 0h-67.727c3.322 0 3.621-7.59 4.252-10.414C-56.931-39.682-31.089-61.664 0-62.301c31.089.637 56.931 22.619 63.475 51.887C64.106-7.59 64.405 0 67.727 0Z"
        clip-path="url(#c)"
        fill="currentColor"
        fillOpacity="1"
        fillRule="nonzero"
        stroke="none"
        transform="matrix(1.33333 0 0 -1.33333 118.518 33.741)"
      />
      <text
        xmlSpace="preserve"
        transform="matrix(1.33333 -.00163 .00163 1.33333 90.37 75.769)"
      >
        <tspan
          x="0"
          y="0"
          fontVariant="normal"
          fontWeight="700"
          fontStretch="normal"
          fontSize="20.3731px"
          fontFamily="CalifornianFB-Bold"
          writingMode="lr-tb"
          fill="#fff"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
        >
          {props.title}
        </tspan>
      </text>
    </svg>
  );
};

export default ItemLabel;
